<template>
    <div>
        <multiselect v-model="selected" :class="validateError != '' ? 'box-border-color' : ''" :clear-on-select="!multiple"
            :close-on-select="!multiple" :disabled="disabled" :deselect-label="''" :multiple="multiple" :options="options"
            :placeholder="$t('select')" :select-label="''" :selected-label="''" label="text" track-by="value"
            @input="handleInput($event, multiple)">
            <template slot="selection" slot-scope="{ values, search, isOpen}" v-if="multiple">
                <span v-if="values.length && !isOpen" class="multiselect__single">
                    {{ translateNSelected(values) }}
                </span>
            </template>
            <span slot="noOptions">{{ $t('no_options') }}</span>
            <span slot="noResult">{{ $t('no_result') }}</span>
        </multiselect>
        <span class="invalid-feedback-custom" v-show="validateError" v-html="validateError" />
    </div>
</template>

<script>
// Helpers
import translateNSelected from '@/helpers/translateNSelected';
import handleInput from '@/helpers/handleInput';
import setSelected from '@/helpers/setSelected';
import qs from "qs"

// Services
import UnihallQuotaPriceService from '@/services/UnihallQuotaPriceService';

export default {
    props: {
        value: {
            default: null
        },
        quota: {
            type: [Number, Boolean,null],
            default: false,
            required: true
        },
        valueType: {
            type: String,
            default: 'id'
        },
        multiple: {
            type: Boolean,
            default: false
        },
        validateError: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    watch: {
        value: function (newValue) {
            this.selected = this.setSelected(newValue, this.options, this.multiple)
        },
        'quota': {
            handler(val) {
                if (!val) return
                this.getOptions(val);
            },
            immediate: true
        }
    },
    data() {
        return {
            selected: null,
            options: []
        }
    },
    methods: {
        translateNSelected,
        handleInput,
        setSelected,
        getOptions(id) {
            if (!id) {
                return
            }
            this.options = []
            const config = {
                params: {
                    limit: -1,
                    filter: {
                        unihall_quota_id: id
                    }
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            };

            UnihallQuotaPriceService.getAll(config)
                .then(response => {
                    const data = response.data.data;
                    data.map(item => {
                        this.options.push({
                            value: item.id,
                            text: `${item.price} ${item.currency}  ${item.installment == 1 ? this.$t('cash') : `${item.installment} ${this.$t('installment')}`}`
                        })
                    })
                })
                .then(() => {
                    this.selected = this.setSelected(this.value, this.options, this.multiple)
                })
        }
    },
    mounted() {
        this.getOptions(this.quota);
    }
}
</script>
